// Recovered compiled webpack factory 40789. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  a.d(t, { j: () => r });
  let r = "https://discord.gg/YZzPxEbNt6";
}
